import React, { useState } from "react";
import { observer } from "mobx-react";

// Chronological activity rail. Read-only: the agent already has the data, so
// this is presentation, and the interactions live on the records it points at.
const PREVIEW_EVENTS = 6;

// Event type → the same material icon the activity pages use for that action.
const TYPE_ICONS = [
  [/reply|replied/i, "reply"],
  [/bounce/i, "error_outline"],
  [/open/i, "drafts"],
  [/click/i, "ads_click"],
  [/email|sent|mail/i, "mail_outline"],
  [/call|phone|dial/i, "call"],
  [/linkedin|connection|inmail/i, "person_add_alt"],
  [/task/i, "task_alt"],
  [/meeting|booked/i, "event_available"],
  [/export|import|bulk/i, "sync_alt"],
  [/note/i, "sticky_note_2"]
];

const iconFor = event => {
  const haystack = `${event.type || ""} ${event.title || ""}`;
  const match = TYPE_ICONS.find(([pattern]) => pattern.test(haystack));
  return match ? match[1] : "radio_button_unchecked";
};

const formatWhen = atLabel => {
  if (!atLabel) return "";
  const date = new Date(atLabel);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
};

const TimelineBlock = observer(({ block }) => {
  const [expanded, setExpanded] = useState(false);
  const events = block.events || [];
  if (!events.length) return null;

  const shown = expanded ? events : events.slice(0, PREVIEW_EVENTS);
  const hidden = events.length - shown.length;

  return (
    <div className="copilotTimeline">
      {block.title && <div className="copilotTimeline__title">{block.title}</div>}
      <ol className="copilotTimeline__list">
        {shown.map((event, index) => (
          <li className="copilotTimeline__item" key={`${event.atLabel}-${index}`}>
            <span className="copilotTimeline__marker" aria-hidden="true">
              <i className="material-icons-outlined">{iconFor(event)}</i>
            </span>
            <div className="copilotTimeline__content">
              <div className="copilotTimeline__head">
                <span className="copilotTimeline__eventTitle">
                  {event.title || event.type}
                </span>
                {formatWhen(event.atLabel) && (
                  <time className="copilotTimeline__when" dateTime={event.atLabel}>
                    {formatWhen(event.atLabel)}
                  </time>
                )}
              </div>
              {event.type && event.title && event.type !== event.title && (
                <div className="copilotTimeline__type">{event.type}</div>
              )}
              {event.detail && (
                <div className="copilotTimeline__detail">{event.detail}</div>
              )}
            </div>
          </li>
        ))}
      </ol>
      {hidden > 0 && (
        <button
          type="button"
          className="copilotTimeline__more"
          aria-expanded={expanded}
          onClick={() => setExpanded(true)}
        >
          {`Show ${hidden} earlier event${hidden === 1 ? "" : "s"}`}
        </button>
      )}
    </div>
  );
});

export default TimelineBlock;
